module.exports = __webpack_public_path__ + "static/marriage-78313a52836ef2ac71b4a34b0583213e.png";